import React from 'react'
import { Header, Container } from 'semantic-ui-react'
import './About.less'

import Layout from '../components/Layout'
import SmallIcon from '../components/icons/SmallIcon'
import RegenerativeIcon from '../components/icons/RegenerativeIcon'
import SeasonalIcon from '../components/icons/SeasonalIcon'
import LocalIcon from '../components/icons/LocalIcon'

import BackgroundImage from '../assets/images/vegetable-basket.jpg'


const principles = [
  {
    title: "Eat with the seasons.",
    description: "Eating with the seasons means supporting what’s produced around us. It inherently adds variety to our diet, supporting our body the way it needs to be supported each season.",
    icon: <SeasonalIcon />
  }, {
    title: "Buy Local.",
    description: "By supporting local producers, we’re strengthening the community we live in, and we’re reconnecting to the ecosystem and environment that enables us to thrive… not to mention it’s the freshest source of nourishment you can get.",
    icon: <LocalIcon />
  }, {
    title: "Opt for small and distributed.",
    description: "Supporting the small, integrated farms in our community enables a more diverse, robust local food system. Large scale producers usually depend on monocultures and heavy use of external inputs. While smaller isn’t always better, it’s typically the small to medium scale farms that are able to enhance biodiversity and ecosystem resilience.",
    icon: <SmallIcon />
  }, {
    title: "Ask about regenerative production methods.",
    description: "Sustainable food production conserves or even enhances the natural resources upon which it depends. It integrates all parts of the farm to maximize earth’s natural ability to cycle nutrients and waste. Whether it’s grazing cattle in ways that restore degraded soils  or a crop rotation that mixes annual and perennial species to put nutrients back in the system, these methods create ecological balance, increase productivity, and enhance biodiversity even as they yield the most nutrient dense foods.",
    icon: <RegenerativeIcon />
  }
]

const renderPrinciple = (principle, i) => {
  return (
    <div className="step-container" key={i}>
      <div>{principle.icon}</div>
      <div className="step-content">
        {
          principle.title &&
          <Header as="h5" className="san-serif">
            {principle.title}
          </Header>
        }
        <p>{principle.description}</p>
      </div>
    </div>
  )
}

const heroStyle = {
  backgroundImage: `url(${BackgroundImage})`,
  backgroundSize: `cover`
}

const FoodPrinciples = () => {
  return (
    <Layout>
      <Container>
        <section className='hero'>
          <div className='background-image' style={heroStyle}></div>
        </section>
        <section className='title inverse'>
          <div className='content-container'>
            <Header as='h1' className='bold'>Guiding Principles</Header>
            <div className='content'>
              <p>
                It should be easy to make food choices that <span className='bold'>align with our values</span>.
                <br/>
                Below are the values that guide our decisions.
              </p>
            </div>
          </div>
        </section>
        <section className='philosophies'>
          <Header as='h1' className='green bold'>Values</Header>
          <div className='content'>
            { principles.map((p, i) => renderPrinciple(p, i))}
          </div>
        </section>
      </Container>
    </Layout>
  )
}

export default FoodPrinciples
